module.exports = "https://static.energy5.com/_next/static/images/aboutUsHeaderBg-c6f0f15dbfd84edbd75d0fa37cda9040.png";